import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  useRouter,
} from 'vue-router'

// import admin from '../admin/routes/index'
import app from '../main/routes/index'
import Auth from '@/utils/Auth'
import { salesClosed, registrationClosed, isNewPurchasePath } from '@/utils/ServiceAvailability'

const routes: Array<RouteRecordRaw> = [...app]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: (to, from, savedPosition) => savedPosition ?? { top: 0 },
})

router.beforeEach((to, from) => {
  if (registrationClosed && to.path === '/register') {
    return { path: '/login', query: { redirect: to.query.redirect } }
  }
  if (salesClosed && isNewPurchasePath(to.path)) {
    return { path: '/informasi-layanan' }
  }
  if (to.meta.requiresAuth && !Auth.isLoggedIn()) {
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    }
  }
  if (
    to.meta.requiresAuth &&
    to.meta.adminOnly &&
    Auth.isLoggedIn() &&
    !Auth.isAdmin() &&
    !Auth.isMentor()
  ) {
    return {
      path: '/',
    }
  }
  if (to.meta.guestOnly && Auth.isLoggedIn()) {
    return {
      path: '/',
    }
  }
})

router.afterEach((to, from) => {
  console.log(document.title)
  document.title = to.meta.title || ''
})

export default router
